<script>

	import Layout from '@/layouts/layoutA'
	import BlogListings from '@/components/BlogListings'
	import InfiniteLoading from 'vue-infinite-loading'
	import FeaturedBlogArticle from '@/components/FeaturedBlogArticle'

	const ArticleOverview = {
		props: {
			featured: {
				type: Function,
				required: true
			},
			intro: Function,
			listings: {
				type: Function,
				required: true
			}
		},
		render () {
			return (
				<Layout>
					<template slot="mastheadOverride">
						{this.featured()}
					</template>
					<div slot="body">
						{this.intro && (
							<div class="intro">
								<container>
									{this.intro()}
								</container>
							</div>
						)}
						{this.listings()}
						{this.$listeners.infinite && (
							<div class="loading">
								<InfiniteLoading onInfinite={this.$listeners.infinite}>
									<template slot="no-more">
										<p>The End!</p>
									</template>
								</InfiniteLoading>
							</div>
						)}
					</div>
				</Layout>
			)
		}
	}

	ArticleOverview.Featured = FeaturedBlogArticle
	ArticleOverview.Listings = BlogListings

	export default ArticleOverview

</script>

<style lang="scss" scoped>
	.intro {
		margin-top: 3rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/ArticleOverview/index.vue